import { createEvent, restore, sample } from 'effector'
import { or } from 'patronum'
import { libraryFavoritesWidget } from '~/widgets/library/favorites'
import { libraryPurchasedWidget } from '~/widgets/library/purchased'

export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

const $isAnyInitFxPending = or(
  libraryFavoritesWidget.$isAnyFavoritesFxPending,
  libraryPurchasedWidget.$isAnyPurchasedFxPending
)

sample({
  clock: $isAnyInitFxPending,
  target: setContentLoading,
})
